import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from './Navigation';
import RequestDemoForm from './RequestDemoForm';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from './Footer';
const Logo = () => (
  <Link to="/" className="text-white font-bold text-xl">
    Lifelike Agents
  </Link>
);

const RequestDemoPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleFormNotification = (type, message) => {
    if (type === 'success') {
      toast.success(message, {
        position: "top-center",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        style: {
          fontSize: '1.1rem',
          padding: '16px',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: '12px',
          maxWidth: '500px',
          margin: '0 auto',
        }
      });
    } else if (type === 'info') {
      toast.info(message, {
        position: "top-center",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        style: {
          fontSize: '1.1rem',
          padding: '16px',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: '12px',
          maxWidth: '500px',
          margin: '0 auto',
        }
      });
    } else {
      toast.error(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        style: {
          fontSize: '1.1rem',
          padding: '16px',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: '12px',
          maxWidth: '500px',
          margin: '0 auto',
        }
      });
    }
  };

  return (
    <div className="landing-page bg-background min-h-screen">
      <Navigation />
      <ToastContainer theme="dark" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Book Your Personal{' '}
            <span className="bg-gradient-to-r from-[#FF56A5] via-[#E852FF] to-[#9F44F2] bg-clip-text text-transparent">
              Demo
            </span>
          </h1>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto mb-2">
            Experience firsthand how our AI-powered call center can transform your business operations
          </p>
          <p className="text-gray-400 text-sm max-w-2xl mx-auto">
            Prefer to schedule a specific time? {' '}
            <a 
              href="mailto:info@lifelikeagents.com"
              className="text-[#E852FF] hover:text-[#FF56A5] transition-colors duration-200"
            >
              Send us an email
            </a>
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-1">
            <div className="bg-gradient-to-br from-[#FF56A5]/20 via-[#E852FF]/20 to-[#9F44F2]/20 rounded-2xl p-8">
              {/* Feature Highlights */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#FF56A5]/20 to-[#E852FF]/20 flex items-center justify-center border border-[#FF56A5]/20">
                    <svg className="w-5 h-5 text-[#FF56A5]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-white font-semibold">Seamless Integration</h3>
                    <p className="text-gray-400 text-sm">Professional onboarding</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#E852FF]/20 to-[#9F44F2]/20 flex items-center justify-center border border-[#E852FF]/20">
                    <svg className="w-5 h-5 text-[#E852FF]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-white font-semibold">Enterprise Ready</h3>
                    <p className="text-gray-400 text-sm">Built for scale</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#9F44F2]/20 to-[#FF56A5]/20 flex items-center justify-center border border-[#9F44F2]/20">
                    <svg className="w-5 h-5 text-[#9F44F2]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-white font-semibold">ROI Focused</h3>
                    <p className="text-gray-400 text-sm">Immediate value</p>
                  </div>
                </div>
              </div>

              {/* Email Verification Info */}
              <div className="bg-white border-l-4 border-indigo-500 p-4 mb-6 rounded-md">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <svg className="h-5 w-5 text-indigo-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2h-1V9z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <p className="text-sm text-gray-900 font-medium">
                      After submitting the form, you'll receive a verification email.
                    </p>
                    <p className="text-sm text-gray-800 mt-1">
                      As soon as you click the link, an AI agent will call you to briefly learn about your needs. This discovery call helps our team tailor your demo to your use case. Please keep your phone nearby and be ready to speak!
                    </p>
                  </div>
                </div>
              </div>

              {/* Form Container */}
              <div className="bg-white rounded-xl p-6 shadow-2xl relative">
                <div className="absolute inset-0 bg-gradient-to-br from-[#FF56A5]/5 via-[#E852FF]/5 to-[#9F44F2]/5 rounded-xl"></div>
                <div className="relative">
                  <RequestDemoForm onNotification={handleFormNotification} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RequestDemoPage; 